export let data = [
  {
    question: "Are your sex partners.",
    options: [
      { name: "Female", Description: "(10 points)", Score: 15 },
      { name: "Male", Description: " (10 points)", Score: 10 },
      { name: "Trans/Gay", Description: " (15 points)", Score: 15 },
      { name: "Other", Description: " (0 points)", Score: 0 },
      { name: "Decline to Answer", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },
 

  {
    question: "Do your partners have other sex partners?",
    options: [
      { name: "Gay/bi men or trans people ", Description: " (10 points)", Score: 10 },
      { name: "Women or straight men ", Description: " (5 points)", Score: 15 },
      {
        name: "Don't know",
        Description:
          " (5 points) Not knowing about your partner’s sexual activities can increase your risks for HIV and STI ",
        Score: 5,
      },
      { name: "No ", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },
  {
    question: "How often do you use condoms?",
    options: [
      {
        name: "Always ",
        Description:
          " (5 points) It has been determined that condoms made of latex, polyurethane, nitrile and polyisoprene are impermeable to HIV, meaning that HIV cannot pass through them. Condoms can fail to prevent an exposure to HIV if they break, slip or leak during sex.",
        Score: 5,
      },
      { name: "Sometime  ", Description: " (10 points)", Score: 10 },
      { name: "Never", Description: " (15 points)", Score: 15 },
    ],
    showOn: ["all", ""],
  },
  {
    question: "Have you ever received an HIV test?",
    options: [
      { name: "Yes", Description: " (0 points)", Score: 0 },
      { name: "No", Description: " (10 points)", Score: 10 },
      { name: "Unsure", Description: " (5 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },

  {
    question: "If you have received an HIV test, was it in the last year?",
    options: [
      { name: "Yes", Description: " (0)", Score: 0 },
      { name: "No", Description: " (10 points)", Score: 10 },
      { name: "Unsure", Description: " (0 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },
  {
    question: "Do you have hepatitis or tuberculosis (TB)?",
    options: [
      { name: "Yes", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points)", Score: 0 },
      { name: "Unsure", Description: " (5 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "Since your last HIV/STI test have you had anal or vaginal sex without a condom?",
    options: [
      { name: "Yes", Description: " (15 points)", Score: 15 },
      { name: "No", Description: " (0 points)", Score: 0 },
      { name: "Sometimes", Description: " (10 points)", Score: 10 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "In the last 12 months, have you had a sexually transmitted infection (STI) such as Chlamydia, Gonorrhea, Syphilis, etc.?",
    options: [
      { name: "Yes, it was treated", Description: " (5 points)", Score: 5 },
      { name: "Yes, it was untreated", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "Have you or your partner(s) been diagnosed with herpes in the past 12 months?",
    options: [
      { name: "Yes, it was treated", Description: " (5 points)", Score: 5 },
      { name: "Yes, it was untreated", Description: " (10 points) ", Score: 10 },
      { name: "No", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },
  {
    question: "How do you have sex?",
    options: [
      { name: "Anal - Top (inserting) ", Description: " (10 points)", Score: 10 },
      { name: "Anal - Bottom (receiving)", Description: " (5 points)", Score: 5 },
      { name: "Vaginal – Inserting ", Description: " (5 points)", Score: 5 },
      { name: "Vaginal – Receiving ", Description: " (5 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "Since your last HIV/STI test have you exchanged sex for drugs, money, or something you needed?",
    options: [
      { name: "Yes ", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },

  {
    question:
      "Since your last HIV/STI test have you had vaginal or anal sex with a person who is HIV positive?",
    options: [
      { name: "Yes ", Description: " (15 points)", Score: 15 },
      { name: "No", Description: " (0 points)", Score: 0 },
      { name: "Unsure", Description: " (10 points)", Score: 10 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "Since your last HIV/STI test have you had vaginal or anal sex with a person who uses injection drugs?",
    options: [
      { name: "Yes ", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points) ", Score: 0 },
      { name: "Unsure", Description: " (5 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },
  {
    question: "Since your last HIV/STI test have you used injection drugs?",
    options: [
      { name: "Yes ", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points)", Score: 0 },
    ],
    showOn: ["all", ""],
  },
  {
    question:
      "    If using injection drugs, did you share injection equipment? Such as sharing needles, ties, cookers etc.",
    options: [
      { name: "Yes ", Description: " (10 points)", Score: 10 },
      { name: "No", Description: " (0 points) ", Score: 0 },
      { name: "Unsure", Description: " (5 points)", Score: 5 },
    ],
    showOn: ["all", ""],
  },
];
